import { render, staticRenderFns } from "./VehicleBrandModelVersionSelector.vue?vue&type=template&id=641a6a9d"
import script from "./VehicleBrandModelVersionSelector.vue?vue&type=script&lang=js"
export * from "./VehicleBrandModelVersionSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports